import { ROUTES } from '@/constants/routes'
import { AuthLayout } from '@/layouts/AuthLayout'
import { MainLayout } from '@/layouts/MainLayout'
import { Navigate, Route, Routes } from 'react-router-dom'
import { ProtectedRoute } from './ProtectedRoute'
import { SuperadminRoute } from './SuperadminRoute'

// Pages
import ActivityLogsList from '@/features/audit/pages/ActivityLogsList'
import Developers from '@/features/estates/pages/Developers'
import ResidentialComplexes from '@/features/estates/pages/ResidentialComplexes'
import LeadCreate from '@/features/leads/pages/LeadCreate'
import LeadEdit from '@/features/leads/pages/LeadEdit'
import LeadsList from '@/features/leads/pages/LeadsList'
import GlobalSettings from '@/features/settings/pages/GlobalSettings'
import PaymentPackages from '@/features/settings/pages/PaymentPackages'
import Districts from '@/features/streets/pages/Districts'
import DistrictsBig from '@/features/streets/pages/DistrictsBig'
import Streets from '@/features/streets/pages/Streets'
import StreetTypes from '@/features/streets/pages/StreetTypes'
import Subway from '@/features/streets/pages/Subway'
import UserDetail from '@/features/users/pages/UserDetail'
import UsersList from '@/features/users/pages/UsersList'
import Dashboard from '@/pages/Dashboard'
import Login from '@/pages/Login'
import Profile from '@/pages/Profile'

/**
 * Application Routes
 * Main routing configuration
 */
export function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={ <AuthLayout /> }>
        <Route path={ ROUTES.LOGIN } element={ <Login /> } />
      </Route>

      {/* Protected Routes */}
      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path={ ROUTES.DASHBOARD } element={ <Dashboard /> } />

        {/* Profile */}
        <Route path={ ROUTES.PROFILE } element={ <Profile /> } />

        {/* Leads routes */}
        <Route path={ ROUTES.LEADS } element={ <LeadsList /> } />
        <Route path={ ROUTES.LEADS_NEW } element={ <LeadCreate /> } />
        <Route path={ ROUTES.LEADS_EDIT } element={ <LeadEdit /> } />

        {/* Users routes (superadmin only) */}
        <Route
          path={ ROUTES.USERS }
          element={
            <SuperadminRoute>
              <UsersList />
            </SuperadminRoute>
          }
        />
        <Route
          path={ ROUTES.USERS_DETAIL }
          element={
            <SuperadminRoute>
              <UserDetail />
            </SuperadminRoute>
          }
        />
        <Route
          path={ ROUTES.ACTIVITY_LOGS }
          element={
            <SuperadminRoute>
              <ActivityLogsList />
            </SuperadminRoute>
          }
        />

        {/* Settings routes (superadmin only) */}
        <Route
          path={ ROUTES.SETTINGS_GLOBAL }
          element={
            <SuperadminRoute>
              <GlobalSettings />
            </SuperadminRoute>
          }
        />
        <Route
          path={ ROUTES.SETTINGS_PAYMENT_PACKAGES }
          element={
            <SuperadminRoute>
              <PaymentPackages />
            </SuperadminRoute>
          }
        />
        <Route
          path={ ROUTES.SETTINGS_DEVELOPERS }
          element={
            <SuperadminRoute>
              <Developers />
            </SuperadminRoute>
          }
        />
        <Route
          path={ ROUTES.SETTINGS_RESIDENTIAL_COMPLEXES }
          element={
            <SuperadminRoute>
              <ResidentialComplexes />
            </SuperadminRoute>
          }
        />
        <Route
          path={ ROUTES.SETTINGS_STREET_TYPES }
          element={
            <SuperadminRoute>
              <StreetTypes />
            </SuperadminRoute>
          }
        />
        <Route
          path={ ROUTES.SETTINGS_DISTRICTS_BIG }
          element={
            <SuperadminRoute>
              <DistrictsBig />
            </SuperadminRoute>
          }
        />
        <Route
          path={ ROUTES.SETTINGS_DISTRICTS }
          element={
            <SuperadminRoute>
              <Districts />
            </SuperadminRoute>
          }
        />
        <Route
          path={ ROUTES.SETTINGS_SUBWAY }
          element={
            <SuperadminRoute>
              <Subway />
            </SuperadminRoute>
          }
        />
        <Route
          path={ ROUTES.SETTINGS_STREETS }
          element={
            <SuperadminRoute>
              <Streets />
            </SuperadminRoute>
          }
        />

        {/* TODO: Add Properties routes */}
        {/* TODO: Add Clients routes */}
        {/* TODO: Add Agents routes */}
        {/* TODO: Add Deals routes */}
      </Route>

      {/* Default redirect */}
      <Route path={ ROUTES.HOME } element={ <Navigate to={ ROUTES.DASHBOARD } replace /> } />

      {/* 404 - catch all */}
      <Route path="*" element={ <Navigate to={ ROUTES.DASHBOARD } replace /> } />
    </Routes>
  )
}

export default AppRoutes
